import { sureSor } from "../../store/user/user.action";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";

import { apiInstanceFetch } from "../../util/api";
import { setToast } from "../../util/toast";
import panelApi from "../../util/panelApi";
import { Chip, PageHead, Pager, img } from "../../Pages/Panel/kit";
import BlockReason from "../Dialog/BlockReason";
import kopyalaPano from "../../util/kopyala";

const nf = (n) => (Number(n) || 0).toLocaleString("tr-TR");

// Sunucuda ulke adi ingilizce saklaniyor; bayrak goster
const CODES = {
  turkey: "TR", türkiye: "TR", turkiye: "TR", "united arab emirates": "AE", uae: "AE", "saudi arabia": "SA",
  egypt: "EG", iraq: "IQ", syria: "SY", jordan: "JO", lebanon: "LB", kuwait: "KW", qatar: "QA", bahrain: "BH",
  oman: "OM", yemen: "YE", palestine: "PS", morocco: "MA", algeria: "DZ", tunisia: "TN", libya: "LY", sudan: "SD",
  pakistan: "PK", india: "IN", iran: "IR", germany: "DE", france: "FR", "united kingdom": "GB", "united states": "US",
  azerbaijan: "AZ", russia: "RU", netherlands: "NL", italy: "IT", spain: "ES",
};
const flag = (c) => {
  const code = CODES[String(c || "").trim().toLowerCase()];
  return code ? String.fromCodePoint(...[...code].map((ch) => 0x1f1e6 + ch.charCodeAt(0) - 65)) : "";
};

const ago = (d) => {
  if (!d) return "—";
  const s = Math.floor((Date.now() - new Date(d).getTime()) / 1000);
  if (s < 60) return "az önce";
  if (s < 3600) return `${Math.floor(s / 60)} dk önce`;
  if (s < 86400) return `${Math.floor(s / 3600)} sa önce`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} gün önce`;
  return new Date(d).toLocaleDateString("tr-TR");
};

const LOGIN = { 0: "Hızlı", 1: "Google", 2: "E-posta", 3: "Apple", 4: "Facebook" };

const FILTERS = [
  ["", "Tümü", "all"],
  ["online", "Çevrimiçi", "online"],
  ["today", "Bugün katılan", "today"],
  ["buyer", "Satın alan", "buyer"],
  ["host", "Yayıncı", "host"],
  ["blocked", "Engelli", "blocked"],
];

const SORTS = [
  ["new", "En yeni"],
  ["seen", "Son görülen"],
  ["coin", "En çok coin"],
  ["bought", "En çok satın alan"],
];

/// Kullanicilar: sunucu tarafi arama, filtre ve siralama; satirda hizli islemler.
const UserTable = () => {
  const history = useHistory();
  const [rows, setRows] = useState([]);
  const [blockRow, setBlockRow] = useState(null);
  const [total, setTotal] = useState(0);
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(20);
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("");
  const [sort, setSort] = useState("new");
  const [menu, setMenu] = useState("");
  // menu tablonun kaydirma kutusuna takilmasin: ekrana sabit konumda acilir
  const [menuPos, setMenuPos] = useState(null);
  useEffect(() => {
    if (!menu) return;
    const kapat = () => setMenu("");
    window.addEventListener("scroll", kapat, true);
    window.addEventListener("resize", kapat);
    return () => {
      window.removeEventListener("scroll", kapat, true);
      window.removeEventListener("resize", kapat);
    };
  }, [menu]);
  const typing = useRef(null);

  const load = useCallback(
    async (text = q) => {
      setLoading(true);
      try {
        const params = new URLSearchParams({ start: page, limit: size, sort });
        if (text.trim()) params.set("q", text.trim());
        if (filter) params.set("filter", filter);
        const res = await apiInstanceFetch.get(`user/userGet?${params.toString()}`);
        setRows(res?.userAll || []);
        setTotal(res?.userCount || 0);
        setCounts(res?.counts || {});
      } catch (e) {
        setToast("error", e.message);
      }
      setLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, size, sort, filter]
  );

  useEffect(() => {
    load();
  }, [load]);

  // yazarken 400 ms bekleyip ara
  const onSearch = (v) => {
    setQ(v);
    clearTimeout(typing.current);
    typing.current = setTimeout(() => {
      setPage(1);
      load(v);
    }, 400);
  };

  const patchRow = (id, patch) => setRows((list) => list.map((u) => (u._id === id ? { ...u, ...patch } : u)));

  // engelleme sebebi zorunlu: pencere acilir, sebep alinir
  const toggleBlock = (u) => setBlockRow(u);

  const doBlock = async (u, reason) => {
    setBlockRow(null);
    try {
      const r = await axios.patch(`user/isBlock?userId=${u._id}`, { reason });
      if (r?.data?.status === false) return setToast("error", r.data.message || "İşlem başarısız");
      patchRow(u._id, { isBlock: r?.data?.user?.isBlock ?? !u.isBlock, blockReason: reason });
      setToast("success", u.isBlock ? "Engel kaldırıldı" : "Engellendi");
    } catch (e) {
      setToast("error", e.message);
    }
  };

  const makeHost = async (u) => {
    setMenu("");
    if (u.isHost) return;
    if (!window.confirm(`${u.name} yayıncı yapılsın mı?`)) return;
    const r = await panelApi.makeHost(u._id);
    setToast(r?.status ? "success" : "error", r?.message || "İşlem başarısız");
    if (r?.status) patchRow(u._id, { isHost: true });
  };

  const removeHost = async (u) => {
    setMenu("");
    if (!u.isHost) return;
    if (!window.confirm(`${u.name} yayıncılıktan çıkarılsın mı?\n\nYayıncı kaydı ve ajans üyeliği silinir, hesabı normal kullanıcı olarak kalır. Yeniden başvurabilir.`)) return;
    const r = await panelApi.removeHost(u._id);
    setToast(r?.status ? "success" : "error", r?.message || "İşlem başarısız");
    if (r?.status) patchRow(u._id, { isHost: false });
  };

  const makeAgency = async (u) => {
    setMenu("");
    const name = window.prompt("Ajans adı (3-30 karakter)", u.name || "");
    if (!name) return;
    const r = await panelApi.makeAgency(u._id, name);
    setToast(r?.status ? "success" : "error", r?.message || "İşlem başarısız");
  };

  const banDevice = async (u) => {
    setMenu("");
    const reason = window.prompt(`${u.name}: hesap engellenecek, cihazı ve IP'si yasaklanacak.\n\nSebep yaz:`, "");
    if (reason === null) return;
    if (reason.trim().length < 3) return setToast("error", "Sebep yazmalısın");
    const saat = sureSor();
    if (saat === null) return;
    const r = await panelApi.banUser({ userId: u._id, reason: reason.trim(), days: saat / 24, banIp: true });
    setToast(r?.status ? "success" : "error", r?.message || "İşlem başarısız");
    if (r?.status) patchRow(u._id, { isBlock: true });
  };

  const copy = async (text) => {
    const ok = await kopyalaPano(text);
    setToast(ok ? "success" : "error", ok ? `Kopyalandı: ${text}` : "Kopyalanamadı");
  };

  const open = (u) => history.push({ pathname: "/admin/user/userProfile", state: { userId: u._id } });
  const openHistory = (u) => history.push({ pathname: "/admin/user/history", state: { userId: u._id } });

  const td = { verticalAlign: "middle" };
  const sub = { fontSize: 11.5, color: "#6E6E73" };

  return (
    <div onClick={() => menu && setMenu("")}>
      <PageHead title="Kullanıcılar" sub="Ad, e-posta ya da ID ile ara. Satıra tıkla, profili aç." />

      {/* filtre hapları */}
      <div className="d-flex" style={{ gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        {FILTERS.map(([key, label, countKey]) => {
          const on = filter === key;
          return (
            <button
              key={key || "all"}
              type="button"
              className={`btn btn-sm ${on ? "btn-primary" : "btn-outline-secondary"}`}
              onClick={() => {
                setFilter(key);
                setPage(1);
              }}
            >
              {label}
              <span style={{ marginInlineStart: 6, opacity: 0.75, fontWeight: 700 }}>{nf(counts[countKey])}</span>
            </button>
          );
        })}
      </div>

      {/* arama + siralama */}
      <div className="d-flex" style={{ gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        <input
          className="form-control"
          style={{ maxWidth: 320 }}
          placeholder="Ara: ad, e-posta, ID"
          value={q}
          onChange={(e) => onSearch(e.target.value)}
        />
        <select
          className="form-control"
          style={{ maxWidth: 200 }}
          value={sort}
          onChange={(e) => {
            setSort(e.target.value);
            setPage(1);
          }}
        >
          {SORTS.map(([k, l]) => (
            <option key={k} value={k}>
              {l}
            </option>
          ))}
        </select>
        <span style={{ ...sub, alignSelf: "center", marginInlineStart: "auto" }}>{nf(total)} kullanıcı</span>
      </div>

      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          <div className="table-responsive">
            <table className="table" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th>Kullanıcı</th>
                  <th>Durum</th>
                  <th>Coin</th>
                  <th>Cihaz</th>
                  <th>Son görülme</th>
                  <th>Katılım</th>
                  <th style={{ textAlign: "end" }}></th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7}>
                      <div className="badu-empty">Yükleniyor…</div>
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan={7}>
                      <div className="badu-empty">Kullanıcı bulunamadı.</div>
                    </td>
                  </tr>
                ) : (
                  rows.map((u) => (
                    <tr key={u._id} style={{ cursor: "pointer" }} onClick={() => open(u)}>
                      {/* kullanici */}
                      <td style={td}>
                        <div className="d-flex align-items-center" style={{ gap: 10 }}>
                          <div style={{ position: "relative", flex: "none" }}>
                            {u.image ? (
                              <img
                                src={img(u.image)}
                                alt=""
                                onError={(e) => (e.currentTarget.style.visibility = "hidden")}
                                style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover", background: "#EEF0F4" }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: 38,
                                  height: 38,
                                  borderRadius: "50%",
                                  background: "#EEF0F4",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: 700,
                                  color: "#6E6E73",
                                }}
                              >
                                {(u.name || "?").slice(0, 1).toUpperCase()}
                              </div>
                            )}
                            {u.isOnline && (
                              <span
                                style={{
                                  position: "absolute",
                                  right: 0,
                                  bottom: 0,
                                  width: 11,
                                  height: 11,
                                  borderRadius: "50%",
                                  background: "#34C759",
                                  border: "2px solid #fff",
                                }}
                              />
                            )}
                          </div>
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                              {flag(u.country)} {u.name || "—"}{" "}
                              {u.gender && (
                                <span title={String(u.gender).toLowerCase() === "male" ? "Erkek" : "Kadın"} style={{ fontWeight: 800, color: String(u.gender).toLowerCase() === "male" ? "#2F7BF6" : "#E8459B" }}>
                                  {String(u.gender).toLowerCase() === "male" ? "♂" : "♀"}
                                </span>
                              )}
                            </div>
                            <div style={sub}>
                              <span
                                title="Kopyala"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  copy(u.uniqueID);
                                }}
                                style={{ cursor: "copy", fontWeight: 600 }}
                              >
                                ID {u.uniqueID}
                              </span>
                              {u.email && !String(u.email).includes("privaterelay") ? ` · ${u.email}` : ""}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* durum */}
                      <td style={td}>
                        <div className="d-flex" style={{ gap: 4, flexWrap: "wrap" }}>
                          {u.isBlock ? <Chip kind="bad">Engelli</Chip> : <Chip>Aktif</Chip>}
                          {u.isHost && <Chip kind="info">Yayıncı</Chip>}
                          {(u.purchasedCoin || 0) > 0 && <Chip kind="wait">Satın alan</Chip>}
                        </div>
                      </td>

                      {/* coin */}
                      <td style={td}>
                        <b>{nf(u.coin)}</b>
                        {(u.purchasedCoin || 0) > 0 && <div style={sub}>alınan {nf(u.purchasedCoin)}</div>}
                      </td>

                      {/* cihaz */}
                      <td style={td}>
                        {/* cihaz kimligi yeni surumlerde gelir; eski surumde bilinmez */}
                        <div>
                          {String(u.lastDeviceId || "").startsWith("i:")
                            ? "iPhone"
                            : String(u.lastDeviceId || "").startsWith("a:")
                            ? "Android"
                            : // cihaz kimligi yoksa: Apple ile giren iPhone'dan girmistir
                            u.loginType === 3 || String(u.email || "").includes("privaterelay.appleid")
                            ? "iPhone"
                            : "—"}
                        </div>
                        <div style={sub}>{LOGIN[u.loginType] || "—"}</div>
                      </td>

                      <td style={{ ...td, ...sub }}>{u.isOnline ? <b style={{ color: "#1B7F3B" }}>Şimdi</b> : ago(u.lastSeenAt)}</td>
                      <td style={{ ...td, ...sub }}>{new Date(u.createdAt).toLocaleDateString("tr-TR")}</td>

                      {/* islemler */}
                      <td style={{ ...td, textAlign: "end", whiteSpace: "nowrap" }} onClick={(e) => e.stopPropagation()}>
                        <button
                          type="button"
                          className={`btn btn-sm ${u.isBlock ? "btn-outline-secondary" : "btn-outline-danger"}`}
                          onClick={() => toggleBlock(u)}
                          style={{ marginInlineEnd: 6 }}
                        >
                          {u.isBlock ? "Engeli kaldır" : "Engelle"}
                        </button>
                        <span style={{ position: "relative", display: "inline-block" }}>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={(e) => {
                              const r = e.currentTarget.getBoundingClientRect();
                              // asagida yer yoksa yukari acilir
                              const yukari = window.innerHeight - r.bottom < 300;
                              setMenuPos({
                                right: Math.max(8, window.innerWidth - r.right),
                                ...(yukari ? { bottom: window.innerHeight - r.top + 4 } : { top: r.bottom + 4 }),
                              });
                              setMenu(menu === u._id ? "" : u._id);
                            }}
                          >
                            •••
                          </button>
                          {menu === u._id && (
                            <div
                              style={{
                                position: "fixed",
                                ...(menuPos || { right: 16, top: 80 }),
                                zIndex: 2000,
                                minWidth: 200,
                                background: "#fff",
                                border: "1px solid rgba(0,0,0,.09)",
                                borderRadius: 10,
                                boxShadow: "0 12px 32px rgba(0,0,0,.14)",
                                padding: 6,
                                textAlign: "start",
                              }}
                            >
                              {[
                                ["Profili aç", () => open(u)],
                                ["Hareket geçmişi", () => openHistory(u)],
                                ["ID kopyala", () => copy(u.uniqueID)],
                                !u.isHost && ["Yayıncı yap", () => makeHost(u)],
                                u.isHost && ["Yayıncılıktan çıkar", () => removeHost(u), true],
                                ["Ajans yap", () => makeAgency(u)],
                                ["Cihaz + IP yasakla", () => banDevice(u), true],
                              ]
                                .filter(Boolean)
                                .map(([label, fn, danger]) => (
                                  <div
                                    key={label}
                                    onClick={() => {
                                      setMenu("");
                                      fn();
                                    }}
                                    style={{
                                      padding: "7px 10px",
                                      borderRadius: 6,
                                      fontSize: 13,
                                      cursor: "pointer",
                                      color: danger ? "#FF3B30" : "#1D1D1F",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,0,0,.05)")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                                  >
                                    {label}
                                  </div>
                                ))}
                            </div>
                          )}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center" style={{ gap: 10, marginTop: 4 }}>
        <select
          className="form-control"
          style={{ maxWidth: 110 }}
          value={size}
          onChange={(e) => {
            setSize(Number(e.target.value));
            setPage(1);
          }}
        >
          {[20, 50, 100].map((n) => (
            <option key={n} value={n}>
              {n} / sayfa
            </option>
          ))}
        </select>
        <div style={{ flex: 1 }}>
          <Pager page={page} size={size} total={total} onChange={setPage} />
        </div>
      </div>

      <BlockReason row={blockRow} onClose={() => setBlockRow(null)} onConfirm={(reason) => doBlock(blockRow, reason)} />
    </div>
  );
};

export default UserTable;
